"use client";
import { AnalyticsEventParams } from "@/app/lib/models/AnalyticsEventParams";
import FirebaseClientService from "@/app/lib/firebase/FirebaseClient.client";
import { Analytics, logEvent } from "firebase/analytics";
import { sendGAEvent } from "@next/third-parties/google";
import logger from "@/lib/logger";

class KovaadAnalytics {
  private static instance: KovaadAnalytics;
  private static fbAnalytics: Analytics | null;
  private static fbClient: FirebaseClientService;

  private constructor() {}

  public static async getInstance(): Promise<KovaadAnalytics> {
    if (!KovaadAnalytics.instance) {
      KovaadAnalytics.instance = new KovaadAnalytics();
      await KovaadAnalytics.initializeKovaadAnalytics();
    }
    return KovaadAnalytics.instance;
  }

  public static logEvent(
    eventKey: string,
    params?: AnalyticsEventParams,
  ): void {
    if (eventKey && params && params.userId) {
      KovaadAnalytics.getInstance().then((instance) => {
        instance.logFirebaseEvent(eventKey, params);
        instance.logGAEvent(params);
      });
    }
  }

  private static async initializeKovaadAnalytics(): Promise<void> {
    try {
      const client = await FirebaseClientService.getFirebaseClient();
      if (client) {
        KovaadAnalytics.fbClient = client;
        KovaadAnalytics.fbAnalytics = client.getFirebaseAnalytics();
      }
    } catch (e) {
      logger.error("Error initializing Firebase:", { error: String(e) });
    }
  }

  public logGAEvent(params: AnalyticsEventParams): void {
    // Get the current URL
    const currentURL = window.location.href;
    if (currentURL.includes("chat")) {
      sendGAEvent(params, "G-GSY8RY1XXW");
    } else if (currentURL.includes("beta")) {
      sendGAEvent(params, "G-RWVVSN555W");
    } else {
      sendGAEvent(params, "G-7LSRGKHHJP");
    }
  }

  public logFirebaseEvent(
    eventKey: string,
    eventParams?: AnalyticsEventParams,
  ): void {
    if (KovaadAnalytics.fbAnalytics) {
      const currentURL = window.location.href;
      if (eventParams) {
        if (currentURL.includes("chat")) {
          eventParams.site = "chat";
        } else if (currentURL.includes("beta")) {
          eventParams.site = "beta";
        } else if (currentURL.includes("localhost")) {
          eventParams.site = "localhost";
        } else {
          eventParams.site = "others";
        }
        logEvent(KovaadAnalytics.fbAnalytics, eventKey, eventParams);
      }
    } else {
      logger.error(
        `Firebase Analytics not initialized --------- LogFirebaseEvent Failed --- ${eventKey},${JSON.stringify(eventParams)}`,
      );
    }
  }
}

export default KovaadAnalytics;
